import { DocumentNode, gql } from '@apollo/client';

export const PublishReportResultPDF: DocumentNode = gql`
    mutation PublishReportResultPDF($result: ReportResultPDFRequestInput) {
        publishReportResultPDF(result: $result) {
            ID
            Status
            url
            __typename
        }
    }
`;
